import { Box, Fab, Tooltip } from '@mui/material'
import { keyframes } from '@mui/system'
import { Link as RouterLink } from 'react-router-dom'
import { layout, zIndex } from '@/theme'
import { contact } from '@/content/site'
import { WhatsAppIcon } from '@/components/ui/WhatsAppIcon'

// Official WhatsApp brand green.
const WA_GREEN = '#25D366'
const WA_GREEN_DARK = '#1EBE5D'

const ping = keyframes`
  0%   { transform: scale(1);   opacity: 0.5; }
  70%  { transform: scale(1.7); opacity: 0; }
  100% { transform: scale(1.7); opacity: 0; }
`

/**
 * Persistent contact affordance. While the official WhatsApp number is unset
 * (contact.whatsapp === null) it routes to /contact instead of wa.me, so the UI
 * needs no change when the real number is added.
 */
export function WhatsAppFab() {
  const hasNumber = Boolean(contact.whatsapp)
  const href = contact.whatsapp ?? undefined
  const label = hasNumber ? 'Chat on WhatsApp' : 'Contact us — WhatsApp coming soon'

  const linkProps = hasNumber
    ? { component: 'a' as const, href, target: '_blank', rel: 'noopener noreferrer' }
    : { component: RouterLink, to: '/contact' }

  return (
    <Tooltip title={label} placement="left">
      <Fab
        {...linkProps}
        aria-label={label}
        sx={{
          position: 'fixed',
          bottom: layout.fabOffset,
          right: layout.fabOffset,
          zIndex: zIndex.fab,
          bgcolor: WA_GREEN,
          color: '#fff',
          '&:hover': { bgcolor: WA_GREEN_DARK },
        }}
      >
        <Box
          component="span"
          sx={{
            position: 'absolute',
            inset: 0,
            borderRadius: '50%',
            bgcolor: WA_GREEN,
            animation: `${ping} 2.2s ease-out infinite`,
            '@media (prefers-reduced-motion: reduce)': { animation: 'none', opacity: 0 },
          }}
        />
        <Box component="span" sx={{ position: 'relative', display: 'inline-flex' }}>
          <WhatsAppIcon size={26} />
        </Box>
      </Fab>
    </Tooltip>
  )
}
